import React, { useState } from "react";
import { Col, Row, Button, Table, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import familyData from "../../../assets/data/familyData.json";

export default function FamilyFilter() {
  const [familyNum, setFamilyNum] = useState("");
  const [cnicNo, setCnicNo] = useState("");
  const [name, setName] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();

    // Normalize input values
    const normalizedFamilyNum = familyNum.toLowerCase();
    const normalizedCnicNo = cnicNo.replaceAll("-", "");
    const normalizedName = name.toLowerCase();

    // Filter data based on inputs
    const filtered = familyData.filter((item) => {
      const matchesFamilyNum = normalizedFamilyNum
        ? item.fsf_id.toLowerCase().includes(normalizedFamilyNum)
        : true;
      const matchesCnicNo = normalizedCnicNo
        ? item.cnic_no.replaceAll("-", "").includes(normalizedCnicNo)
        : true;
      const matchesName = normalizedName
        ? item.name.toLowerCase().includes(normalizedName)
        : true;

      return matchesFamilyNum && matchesCnicNo && matchesName;
    });

    // Update state with filtered data and show modal
    setFilteredData(filtered);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter Families"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Data Filter"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Filter Families"}</li>
              </ul>
            </div>
          </div>
        </Col>

        {/* Filters */}
        <Col xl={4}>
          <Form.Group className="mb-3">
            <Form.Label>Filter by Family Number</Form.Label>
            <Form.Control
              onChange={(e) => setFamilyNum(e.target.value)}
              value={familyNum}
              type="text"
              placeholder="Family Number (FSF-)"
            />
          </Form.Group>
        </Col>
        <Col xl={4}>
          <Form.Group className="mb-3">
            <Form.Label>Filter by CNIC</Form.Label>
            <Form.Control
              onChange={(e) => setCnicNo(e.target.value)}
              value={cnicNo}
              type="text"
              placeholder="CNIC No..."
            />
          </Form.Group>
        </Col>
        <Col xl={4}>
          <Form.Group className="mb-3">
            <Form.Label>Filter by Name</Form.Label>
            <Form.Control
              onChange={(e) => setName(e.target.value)}
              value={name}
              type="text"
              placeholder="Enter Name..."
            />
          </Form.Group>
        </Col>

        <Col xl={12}>
          <Button onClick={handleSearch} variant="success">
            Search
          </Button>
        </Col>
      </Row>

      {/* Modal for showing filtered results */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Filtered Families</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {filteredData.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Family ID</th>
                  <th>CNIC</th>
                  <th>Name</th>
                  <th>Entry Date</th>
                  <th>Province</th>
                  <th>Rescued Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.fsf_id}</td>
                    <td>{item.cnic_no}</td>
                    <td>{item.name}</td>
                    <td>{item.entry_date}</td>
                    <td>{item.province}</td>
                    <td>{item.rescued_date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No data found.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
}
